/* eslint-disable */
const axios = require('axios')

export const getMiddle = () => {
  return axios.get('http://ysw.861718.com/gdics.php/index/top')
}



// WEBPACK FOOTER //
// ./src/api.js